import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  row: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },

    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },

  cell: {
    fontFamily: 'Readex Pro',
    fontSize: '14px',
    color: '#0F0F0F',
    padding: '16px',
    // borderRight removed for consistency
    borderRight: 'none',
    verticalAlign: 'top',

    '&:last-child': {
      borderRight: 'none',
    },
  },

  description: {
    lineHeight: 1.5,
    wordBreak: 'break-word',

    '& .emphasizedValue': {
      fontWeight: 400, // Regular for emphasized values
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
      padding: '2px 4px',
      borderRadius: '4px',
      color: '#1976D2',
    },
  },

  timestamp: {
    whiteSpace: 'nowrap',
  },

  emptyCell: {
    padding: '0',
    border: 'none',
  },

  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '300px',
    padding: '32px',
    backgroundColor: '#FAFAFA',
    borderRadius: '8px',
    border: '1px solid #E5E5E5',
    textAlign: 'center',
    margin: '16px',
  },

  emptyIcon: {
    fontSize: '48px',
    opacity: 0.5,
    filter: 'grayscale(100%)',
    marginBottom: '16px',
  },

  emptyMessage: {
    fontFamily: 'Readex Pro',
    fontSize: '16px',
    fontWeight: 400,
    color: '#666666',
    marginBottom: '8px',
  },

  emptySubMessage: {
    fontFamily: 'Readex Pro',
    fontSize: '14px',
    fontWeight: 300,
    color: '#999999',
    maxWidth: '300px',
    lineHeight: 1.4,
  },

  // Responsive design
  '@media (max-width: 960px)': {
    cell: {
      fontSize: '13px',
      padding: '12px',
    },

    emptyState: {
      minHeight: '200px',
      padding: '24px',
    },

    emptyIcon: {
      fontSize: '36px',
    },

    emptyMessage: {
      fontSize: '14px',
    },

    emptySubMessage: {
      fontSize: '12px',
    },
  },

  '@media (max-width: 600px)': {
    cell: {
      fontSize: '12px',
      padding: '8px',
    },

    timestamp: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
}));

export default useStyles;
